import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const CardViewIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M7 3V21" stroke="currentColor"></path>
      <path d="M17 3V21" stroke="currentColor"></path>
      <path d="M21 7L3 7" stroke="currentColor"></path>
      <path d="M21 17L3 17" stroke="currentColor"></path>
    </SvgIcon>
  )
}
